import { History, Info, ListTree, Route, Wallet } from "lucide-react";

import useTranslations from "@/shared/lang/useTranslations";

import type { FeeTabId } from "../../types/paymentFees.types";

const INTRO = {
  corridors: { icon: Route, key: "tab_intro_corridors" },
  history: { icon: History, key: "tab_intro_history" },
  commissions: { icon: ListTree, key: "tab_intro_commissions" },
  costs: { icon: Wallet, key: "tab_intro_costs" },
} as const;

export function TabIntro({ tab }: { tab: FeeTabId }) {
  const { t } = useTranslations("paymentFees");
  const { icon: Icon, key } = INTRO[tab] ?? { icon: Info, key: "tab_intro_corridors" };
  return (
    <p className="flex items-start gap-2.5 rounded-xl bg-muted/50 px-4 py-3 text-sm text-muted-foreground">
      <Icon className="mt-0.5 size-4 shrink-0 text-foreground/70" aria-hidden="true" />
      {t(key)}
    </p>
  );
}
